import { getClassNames } from '@websolutespa/bom-core';
import { CanvasOffscreenProvider, Font, Main, Trigger } from '@websolutespa/bom-mixer-llm';
import { AnimatePresence } from 'framer-motion';
import { forwardRef } from 'react';
import '../../../scss/style.scss';
import style from './root.module.scss';

export type RootProps = {
  mode: string;
  opened?: boolean;
  embedded?: boolean;
  customIntro?: boolean;
  shouldShowTrigger?: boolean;
};

export const Root = forwardRef<HTMLDivElement, RootProps>(
  function Root({
    opened,
    embedded,
    customIntro,
    shouldShowTrigger,
    mode,
  }, ref) {

    const classNames = getClassNames('llm', style.root, {
      '-open': opened,
      '-embedded': embedded,
      '-custom-intro': customIntro,
      [style['-' + mode]]: true,
    });

    return (
      <section ref={ref} className={classNames}>
        <CanvasOffscreenProvider>
          <Font />
          <AnimatePresence mode="wait" initial={false}>
            {opened && (
              <Main key="main" />
            )}
          </AnimatePresence>
          <AnimatePresence mode="wait" initial={false}>
            {shouldShowTrigger && (
              <Trigger key="trigger" />
            )}
          </AnimatePresence>
        </CanvasOffscreenProvider>
      </section>
    );
  }
);
